import { useMemo } from 'react';

import { expVal } from '@confluence/feature-experiments';
import { useIsDesktop } from '@confluence/desktop-native-bridge';

type Options = {
	disabled: boolean;
	collabEditInternetLost: boolean;
	internetDisconnected: boolean;
};

/**
 * Hook to determine if we should disable the editor contents based on the current
 * state of connectivity.
 *
 * @param options Options for hook
 * @param options.disabled If the editor component is currently disabled
 * @param options.collabEditInternetLost If the collab edit has disconnected
 * @param options.internetDisconnected If the internet is disconnected
 * @returns boolean - if the component is disabled
 */
export const useEditorContentDisabled = ({
	disabled,
	collabEditInternetLost,
	internetDisconnected,
}: Options) => {
	const { isDesktop } = useIsDesktop();

	return useMemo(() => {
		return isDesktop || expVal('platform_editor_offline_editing_web', 'isEnabled', false)
			? disabled && !(collabEditInternetLost || internetDisconnected)
			: disabled;
	}, [isDesktop, collabEditInternetLost, internetDisconnected, disabled]);
};
